import i18n from 'utils/i18n'
import type { AdminCompaniesFilterName } from 'utils/filters/admin'
import type { TableFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import {
  filterTypes,
  CHECKBOX_LIST,
  DATE_INTERVAL,
  RADIO_LIST,
  SEARCH_USERS,
  ADMIN_FILTERS_KEY,
  ADMIN_FILTERS_TITLE,
  ADMIN_FILTERS_NAME,
} from 'utils/consts'

export const getAdministrationCompaniesFilterCollection = () => [
  {
    type: filterTypes[SEARCH_USERS],
    title: i18n.t(ADMIN_FILTERS_TITLE.userFilter),
    filterName: ADMIN_FILTERS_NAME.userFilter,
    apiFilterName: ADMIN_FILTERS_KEY.userFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.verificationFilter),
    filterName: ADMIN_FILTERS_NAME.verificationFilter,
    apiFilterName: ADMIN_FILTERS_KEY.verificationFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.categoryFilter),
    filterName: ADMIN_FILTERS_NAME.categoryFilter,
    apiFilterName: ADMIN_FILTERS_KEY.categoryFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.stripeIdStatusFilter),
    filterName:
      ADMIN_FILTERS_NAME.stripeIdStatusFilter satisfies AdminCompaniesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.stripeIdStatusFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.createdAtFilter),
    filterName:
      ADMIN_FILTERS_NAME.createdAtFilter satisfies AdminCompaniesFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.createdAtFilter,
  },
]

export const adminCompaniesFiltersConfig: TableFiltersConfig = {
  getFiltersCollection: getAdministrationCompaniesFilterCollection,
  pathToStore: ['offers'],
  filtersDataPath: ['admin', 'companies', 'companiesFilters'],
  showResultsTextKey: 'filters.button.apply',
  showPresets: false,
}
